export default function TestkitFactory(moment) {
    const fn = this;

    fn.constructor = function () {};

    /**
     * APIV3
     *
     */

    fn.createTestKitSearch = function (json) {
        json.ParentLanes[0].Lanes.forEach((lane) => {
            lane.Prices.forEach((period) => {
                /**
                 * indicator to force DummyApi checkResource unavailable response
                 */

                period.dummyApiObj = {
                    available:
                        moment(period.BookingStart).hour() == "22"
                            ? false
                            : true,
                };
            });
        });

        return json;
    };

    /**
     * Utilz
     */

    fn.log = function (str, json, color) {
        Log.obj("DummyAPI: " + str, json, color);
    };

    fn.constructor();

    return fn;
}
